<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="px-11 pt-10 pb-9 white">
      <v-row>
        <v-col cols="11">
          <p class="form__title mb-0 primary--text">
            MIGRAR CARTEIRA PARA:
          </p>
        </v-col>
        <v-col cols="1" class="text-end">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12">
          <BaseFormSelect
            id-element="nameMigrateContact"
            placeholder="Seleção"
            v-model="form.nome"
            required
            :rules="[requiredInput]"
            label-text="Nome"
            :items="list"
            item-text="nome"
            item-value="id"
            :return-object="false"
          />
        </v-col>
        <v-col cols="12" class="yellow py-3 px-4">
          <p class="primary--text font-weight-bold caption mb-0">
            *Essa ação realiza a troca do atendimento do atendente nos limites
            de crédito cadastrado nos grupos financeiros.
          </p>
        </v-col>
      </v-row>
      <v-row class="pt-12">
        <v-spacer />
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            width="100%"
            class="secondary white--text"
            @click="submit"
            v-html="'ADICIONAR'"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
export default {
  data: () => ({
    form: {},
    requiredInput
  }),
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form.nome);
    }
  },
  props: {
    list: {
      type: Array
    }
  }
};
</script>
